<template>
  <div :style="containerStyle">
    <slot />
    <DummyItemCardPrimary v-for="index in 12 - (itemLength % 12 + 1)"
                         :key="index + '_'" />
  </div>
</template>

<script>
  import DummyItemCardPrimary from '@modules/card/dummy-item-card-primary'

  export default {
    name: 'ItemCardListPrimary',
    components: {
      DummyItemCardPrimary,
    },
    props: {
      itemLength: { type: Number, required: false, default: 0 },
    },
    data: function () {
      return {
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          padding: '0 12px',
        },
      };
    },
  };
</script>
